import isEqual from 'lodash/isEqual';
import pickBy from 'lodash/pickBy';

import {Store, QuicksurveyStore} from 'client/common/types';

import {ListFilter, ListItem, ListMode} from 'client/common/store/reducers/surveys/types';

import {initialState} from 'client/common/store/reducers/surveys';

import {getUserIsAgency, getUserIsAgencyClient} from 'client/common/store/selectors/user';

export function getPaginationKey(state: QuicksurveyStore): string | undefined {
    return state.surveys.paginationKey;
}

export function getSurveyFilter(state: QuicksurveyStore): ListFilter {
    return state.surveys.filter;
}

export function getIsDefaultFilter(state: QuicksurveyStore): boolean {
    const existingFilter = pickBy(state.surveys.filter, value => value !== undefined);

    return isEqual(existingFilter, initialState.filter);
}

export function getSurveyList(state: QuicksurveyStore): ListItem[] {
    return state.surveys.list;
}

export function getIsEntirelyLoaded(state: QuicksurveyStore): boolean {
    return state.surveys.isEntirelyLoaded;
}
export function getIsLoadingSurveysList(state: QuicksurveyStore): boolean {
    return state.surveys.IsLoadingSurveysList;
}

export function getListMode(state: Store): ListMode {
    const userIsAgency = getUserIsAgency(state);
    const userIsAgencyClient = getUserIsAgencyClient(state);

    if (userIsAgency) {
        return ListMode.Agency;
    }

    if (userIsAgencyClient) {
        return ListMode.AgencyClient;
    }

    return ListMode.User;
}
